import React, { useEffect, useState } from 'react';
import {
  TIMELINE_DRIFT_CAUSES,
  TIMELINE_DRIFT_CAUSE_LABELS,
  type TimelineDriftCause,
} from '../../utils/timelineDrift';
import './RecordMoveReasonPopup.css';

interface RecordMoveReasonPopupProps {
  taskTitle: string;
  onSkip: () => void;
  onRecord: (cause: TimelineDriftCause) => void;
}

const RecordMoveReasonPopup: React.FC<RecordMoveReasonPopupProps> = ({
  taskTitle,
  onSkip,
  onRecord,
}) => {
  const [record, setRecord] = useState(false);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onSkip();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onSkip]);

  return (
    <div className="pm-move-reason-overlay" onClick={onSkip}>
      <div
        className="pm-move-reason-card"
        role="dialog"
        aria-labelledby="pm-move-reason-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div id="pm-move-reason-title" className="pm-move-reason-title">
          Record reason for move?
        </div>
        <p className="pm-move-reason-sub">{taskTitle}</p>
        <label className="pm-move-reason-check">
          <input
            type="checkbox"
            checked={record}
            onChange={(e) => setRecord(e.target.checked)}
          />
          Record a reason
        </label>
        {record && (
          <div className="pm-move-reason-chips">
            {TIMELINE_DRIFT_CAUSES.map((cause) => (
              <button
                key={cause}
                type="button"
                className="pm-move-reason-chip"
                onClick={() => onRecord(cause)}
              >
                {TIMELINE_DRIFT_CAUSE_LABELS[cause]}
              </button>
            ))}
          </div>
        )}
        <button type="button" className="pm-btn pm-btn-sm pm-btn-primary pm-move-reason-skip" onClick={onSkip}>
          Skip
        </button>
      </div>
    </div>
  );
};

export default RecordMoveReasonPopup;
